// @flow
export const OPEN_LOADER = 'loader/open_loader'
export const CLOSE_LOADER = 'loader/close_loader'

type State = {
  open: boolean,
}

type Action = {
  type: string,
  payload: any,
}

const initialState: State = {
  open: false,
}

export default (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case OPEN_LOADER:
      return {
        ...state,
        open: true,
      }
    case CLOSE_LOADER:
      return {
        ...state,
        open: false,
      }
    default:
      return state
  }
}
